var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"member-configuration"},[_c('TopBotLayout',{scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('Header',{attrs:{"memberList":_vm.memberList}})]},proxy:true},{key:"bot",fn:function(){return [_c('MemberConfigurationTable')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }